/* capkov-rd: dárková karta – přepínač digitální/fyzická, hodnoty, živý náhled karty (jméno + vzkaz). Košík řeší is="product-form" z theme.js. */
(function () {
  'use strict';
  var root = document.querySelector('[data-rdgc]'); if (!root) return;
  var $ = function (s, r) { return (r || root).querySelector(s); }, $$ = function (s, r) { return [].slice.call((r || root).querySelectorAll(s)); };
  var amt = $('[data-rdgc-amt]'), to = $('[data-rdgc-to]'), msg = $('[data-rdgc-msg]'), chip = $('[data-rdgc-chip]');
  var D = root.dataset, mode = 'digital';
  function pane() { return $('[data-rdgc-pane="' + mode + '"]'); }
  function sync() {
    var p = pane(); if (!p) return;
    var sel = $('input[type=radio]:checked', p);
    if (sel) {
      amt.textContent = sel.getAttribute('data-price');
      $('[data-rdgc-id]', p).value = sel.value;
      var ap = $('[data-rdgc-addprice]', p); if (ap) ap.textContent = sel.getAttribute('data-price');
    }
    var digital = mode === 'digital', box = $('[data-rdgc-rcp] input[type=checkbox]');
    var name = $('[data-rdgc-name]'), text = $('[data-rdgc-text]'), direct = digital && box && box.checked;
    var nm = direct && name ? name.value.trim() : '', tx = direct && text ? text.value.trim() : '';
    to.hidden = !nm; to.textContent = nm ? D.tFor + ' ' + nm : '';
    msg.textContent = tx || D.tMsg; msg.classList.toggle('is-ph', !tx);
    msg.hidden = !digital;
    chip.textContent = digital ? D.tChipDigital : D.tChipPhysical;
    var cnt = $('[data-rdgc-count]'); if (cnt && text) cnt.textContent = text.value.length + ' / 200';
  }
  function setMode(m) {
    if (!$('[data-rdgc-pane="' + m + '"]')) return;
    mode = m;
    $$('[data-rdgc-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-rdgc-pane') !== m; });
    $$('[data-rdgc-mode]').forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-rdgc-mode') === m ? 'true' : 'false'); });
    var gal = $('[data-rdgc-gal]'), cb = $('[data-rdgc-cardbox]');
    if (gal && cb) { var ph = m === 'physical'; gal.hidden = !ph; cb.hidden = ph; }
    sync();
  }
  function lb(src) {
    var o = document.createElement('div'); o.className = 'rdgc__lb'; o.setAttribute('role', 'dialog'); o.setAttribute('aria-modal', 'true');
    o.innerHTML = '<button type="button" class="rdgc__lbx" aria-label="×">×</button><img alt="">'; o.querySelector('img').src = src;
    function close() { o.remove(); document.removeEventListener('keydown', k); }
    function k(e) { if (e.key === 'Escape') close(); }
    o.addEventListener('click', close); document.addEventListener('keydown', k); document.body.appendChild(o); o.querySelector('button').focus();
  }
  root.addEventListener('click', function (e) {
    var z = e.target.closest('[data-rdgc-zoom]'); if (z) { lb(z.getAttribute('data-full')); return; }
    var t = e.target.closest('[data-rdgc-thumb]'); if (!t) return;
    var im = $('[data-rdgc-galimg]'), zb = $('[data-rdgc-zoom]'); im.src = t.getAttribute('data-src'); zb.setAttribute('data-full', t.getAttribute('data-full'));
    $$('[data-rdgc-thumb]').forEach(function (x) { x.classList.toggle('is-on', x === t); });
  });
  root.addEventListener('click', function (e) { var b = e.target.closest('[data-rdgc-mode]'); if (b) setMode(b.getAttribute('data-rdgc-mode')); });
  root.addEventListener('input', sync); root.addEventListener('change', sync);
  var q = {}; try { location.search.replace(/^\?/, '').split('&').forEach(function (kv) { var p = kv.split('='); q[p[0]] = decodeURIComponent(p[1] || ''); }); } catch (e) { }
  var start = q.mode === 'physical' ? 'physical' : (D.start || 'digital');
  if (q.amount) { var p = $('[data-rdgc-pane="' + start + '"]'); if (p) $$('input[type=radio]', p).forEach(function (r) { if (r.getAttribute('data-price').replace(/\D/g, '') === q.amount.replace(/\D/g, '') || r.getAttribute('data-price').replace(/[^\d]/g, '') === q.amount) { if (!r.disabled) r.checked = true; } }); }
  setMode(start);
  /* theme.js (GiftCardRecipient) může naběhnout až po nás; přepnutí fieldů hlídá on. Jen jistota pro náhled po jeho inicializaci. */
  setTimeout(sync, 400);
})();
